import { apiFetch } from './client';

// Public member-card scan client — no auth, the public_token in the URL
// is the credential. Returns sanitized payment status + theming tokens
// for the public scan page to render in the org's colors.

export interface PublicMemberCard {
  org: {
    name: string;
    slug: string;
    logo_url?: string;
    primary_color?: string;
    accent_color?: string;
  };
  member: {
    display_name: string;
    pii_level: 'full_name' | 'first_name' | 'member_id';
  };
  status: {
    fiscal_year: number;
    paid: boolean;
    invoice_number?: string;
    currency?: string;
    amount_minor?: number;
    paid_at?: string;
  };
  template: {
    background_kind: 'color' | 'image';
    background_color: string;
    text_color: string;
    accent_color: string;
  };
}

export async function getPublicMemberCard(token: string): Promise<PublicMemberCard> {
  return apiFetch<PublicMemberCard>(`/api/v1/public/membercard/${encodeURIComponent(token)}`);
}
